import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from 'environments/environment';
import {  HttpHeaders } from '@angular/common/http';
import { RendezVous } from 'model/rendezvous';
import { Observable, Subject } from 'rxjs';
import { Message } from 'model/modal-cms/message';
import { Rapports } from 'model/modal-cms/rapport_activite';
import { RapportsRembourse } from 'model/modal-cms/rapport_activite_remb';
import { RapportsRemboursSLCTSZ } from 'model/modal-cms/rapport_activite_remb_slc';
import { Iec } from 'model/modal-cms/iec';
import { MedicamentLivre } from 'model/modal-cms/medicament_livre';
import { Epidemimie } from 'model/modal-cms/epidemie';
import { Apropos } from 'model/modal-cms/apropos';
import { Reponse } from 'model/modal-cms/reponse';
import { IecDetail } from 'model/modal-cms/iec_detail';
import { Infra } from 'model/modal-cms/infra';
import { BC } from 'model/modal-cms/bc';
import { BC_detail } from 'model/modal-cms/detail_bc';
import { Users } from 'model/modal-cms/users';
import { Personnel } from 'model/modal-cms/personnel';

@Injectable({
  providedIn: 'root'
})
export class CMSService {

  httpOptions: any = {
    headers: new HttpHeaders({
       'Content-Type': 'application/json',
       'Cookie': 'JSESSIONID=B369491889B2312DD2DD5E4F55A81D7E',
       'access-control-allow-credentials' : 'true'
    })
}
  urlServer = environment.urlServer1;
   urlServer3 = environment.urlServer3;
  public newCribSubect = new Subject<any>();
  public newCribSubect2 = new Subject<any>();
  private photoAgent  : any;
 // headers = new HttpHeaders().set('Content-Type', 'application/json');
 private apiRoot = "http://localhost/SiteCmsServeur/FileIEC/upload/file/iec";

  private headers= new Headers({'Content-Type':'application/json, application/x-www-form-urlencoded;charset=UTF-8',
   'Access-Control-Allow-Origin' : 'http://url-serv/'});
  private options = new RequestOptions({headers:this.headers});


  userIdActuel: number;
  lieuIdActuel: any;
  constructor(public http: Http) { }


  getData(symbol: string): Observable<any> {
    // Tried adding headers with no luck
    const headers = new Headers();
    headers.append('Access-Control-Allow-Headers', 'Content-Type, X-Requested-With');
    headers.append('Content-Type','application/pdf')
    headers.append('Access-Control-Allow-Methods', 'POST,GET,PUT,DELETE,OPTIONS');
    headers.append('Access-Control-Allow-Origin', '*,http://localhost/SiteCmsServeur/FileIEC/upload/file/iec');
    return this.http.get(this.apiRoot + "/" + symbol, {headers: headers})
        .map(response => response.json());
}


  // getListeQuestion() {
  //   return this.http.get(this.urlServer+"Question");
  // }

  getListeQuestion() {
    return this.http.get(this.urlServer + "Question")
      .map(resp => resp.json());
  }

  getListeQuestiobyId(id_mes:any) {
    return this.http.get(this.urlServer+"Question/find/"+id_mes)
      .map(resp => resp.json());
  }

  getListeQuestiobyIdmessacleetranger(id_mes:any) {
    return this.http.get(this.urlServer+"Question/find_idmess/"+id_mes)
      .map(resp => resp.json());
  }

  
  getListeQuestiobyEtatCreer(etat:any) {
    return this.http.get(this.urlServer+"Question/find1/"+etat)
      .map(resp => resp.json());
  }
  
  getListeQuestiobyEtatLire(etat:any) {
    return this.http.get(this.urlServer+"Question/find2/"+etat)
      .map(resp => resp.json());
  } 

  getListeQuestionParMCCom(mcl:any,etat:any) {
    return this.http.get(this.urlServer +"Question/find_mcl_by_com/"+mcl+"/"+etat)
      .map(resp => resp.json());
  }

  getListeQuestionParMCComParDate(mcl:any,etat:any) {
    return this.http.get(this.urlServer +"Question/find_mcl_by_com_by_date/"+mcl+"/"+etat)
      .map(resp => resp.json());
  }


  //pers only
  getListeQuestionParMC(mcl:any,etat:any,im_agent:any) {
      return this.http.get(this.urlServer+"Question/find_mcl_by_agent/"+mcl+"/"+etat+"/"+im_agent)
        .map(resp => resp.json());
    
  }

   getListeQuestionParMCDate(mcl:any,etat:any,im_agent:any) {
      return this.http.get(this.urlServer+"Question/find_mcl_by_agent_date/"+mcl+"/"+etat+"/"+im_agent)
        .map(resp => resp.json());
    
  }



  getListeQuestiobyEtatCreerbyidagent(etat:any,im_agent:any) {
    return this.http.get(this.urlServer+"Question/find_etat_by_agent/"+etat+"/"+im_agent)
      .map(resp => resp.json());
  } 

  getOneQuestio(id_mess:any) {
    return this.http.get(this.urlServer+"Question/find/"+id_mess)
      .map(resp => resp.json());
  } 

  

  setUserId(id: number) {
    this.userIdActuel = id;
    console.log(this.userIdActuel)
    //this.newCribSubect.next(this.userIdActuel);
  }

    //save of rdv on line
    saveRendezVous(r: RendezVous) {
      return this.http.post(this.urlServer3 + "ws/post_rdv", r)
        .map(resp => resp.json());
    }


    saveMessage(m: Message): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(m);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "QuestionCreate", body, options);
  }

  updateMessage(m: Message): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(m);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Question/update/"+ m.id_mess, body, options);  
  }

  //get pdf


  //saveReponseMessage
  saveReponseMessage(r: Reponse): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(r);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "ReponseCreate", body, options);
  }



  //get Liste pers  
  getMed(fonction:any) {
    return this.http.get(this.urlServer+"Personnel/find_med/"+fonction)
      .map(resp => resp.json());
  } 
  
  getAutre(fonction:any) {
    return this.http.get(this.urlServer+"Personnel/find_autre/"+fonction)
      .map(resp => resp.json());
  }

  getAutreParIM(im:any) {
    return this.http.get(this.urlServer+"Personnel/find_autre_im/"+im)
      .map(resp => resp.json());
  }

  //getInfo  
  getInfoMed(im:any) {
    return this.http.get(this.urlServer+"Personnel/find/"+im)
      .map(resp => resp.json());
  }

  

   getInfoMedbyId(im:any) {
    return this.http.get(this.urlServer+"Personnel/findbyIM/"+im)
      .map(resp => resp.json());
  }

   //saveperse
   savePerseCMS(pr: Personnel): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(pr);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "PersonnelCreate", body, options);
  }

  updatePerseCMS(pr: Personnel): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(pr);
    let options = new RequestOptions({headers: headers});
    return this.http.post(this.urlServer+"Personnel/update/"+pr.id_pers, body, options);  
  }


  //Rapport_activite
  getRaportActivitebyIM(im:any) {
    return this.http.get(this.urlServer+"Rapport_activite/find1/"+im)
      .map(resp => resp.json());
  }


  //save & Rapport_Activity  
  saveRaport(r: Rapports): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(r);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "Rapport_activiteCreate", body, options);
  }

  
  updateRaport(r: Rapports): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(r);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Rapport_activite/update/"+ r.id_rap, body, options);  
  }


  

  deleteRaport(id_rap:number): Observable<any> {
    return this.http.delete(this.urlServer + "Rapport_activite/delete/"+id_rap)
      .map(resp => resp.json());
  }
  

  

  getInfoRapportMed(id_rap:any) {
    return this.http.get(this.urlServer+"Rapport_activite/find/"+id_rap)
      .map(resp => resp.json());
  }


  //rapoort rembourse  
  getRaportActiviteRembourseSecDAF161(etat:any) {
    return this.http.get(this.urlServer+"Rapport_activite/find_SecDAF_161/"+etat)
      .map(resp => resp.json());
  }

  getRaportActiviteRembourseSLCTSZ(etat_slc :any) {
    return this.http.get(this.urlServer+"Rapport_activite/find_SLC_TSZ/"+etat_slc )
      .map(resp => resp.json());
  }



  saveRapportRembourseSLC(rapportsRemboursSLCTSZ: RapportsRemboursSLCTSZ): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(rapportsRemboursSLCTSZ);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "Rapport_activite_Rembourse_SLCCreate", body, options);
  }


  updateRapportRembourseSLC(rapportsRemboursSLCTSZ: RapportsRemboursSLCTSZ): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(rapportsRemboursSLCTSZ);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Rapport_activite/update_rembourse/"+ rapportsRemboursSLCTSZ.id_rembourse_slc, body, options);  
  }

  deleteRaportRembourseSLC(id_rap_remb:number): Observable<any> {
    return this.http.delete(this.urlServer + "Rapport_activite/delete_rembourse/"+id_rap_remb)
      .map(resp => resp.json());
  }

  

  saveRaportRembourseSecDAF161(rembourse: RapportsRembourse): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(rembourse);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "Rapport_activite_RembourseCreate", body, options);
  }


  updateRaportRembourseSecDAF161(rembourse: RapportsRembourse): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(rembourse);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Rapport_activite/update_rembourse/"+ rembourse.id_rap_remb, body, options);  
  }

  deleteRaportRembourseSecDAF161t(id_rap_remb:number): Observable<any> {
    return this.http.delete(this.urlServer + "Rapport_activite/delete_rembourse/"+id_rap_remb)
      .map(resp => resp.json());
  }
  

  getInfoRaportRembourseSecDAF161(id_rap_remb:any) {
    return this.http.get(this.urlServer+"Rapport_activite/find_rembourse/"+id_rap_remb)
      .map(resp => resp.json());
  }

  getInfoRaportRembourseSLCTSZ(id_rap_remb:any) {
    return this.http.get(this.urlServer+"Rapport_activite/find_rembourse2/"+id_rap_remb)
      .map(resp => resp.json());
  }

  //getIec info
  getIecAcc(etat : any) {
    return this.http.get(this.urlServer+"Iec/find_etat_Acc/"+etat)
      .map(resp => resp.json());
  }

  getIec(etat : any) {
    return this.http.get(this.urlServer+"Iec/find_etat/"+etat)
      .map(resp => resp.json());
  }

  getIecImage(moc_img :any) {
    return this.http.get(this.urlServer+"Iec/find_iec_image/" + moc_img)
      .map(resp => resp.json());
  }

   getDefaultVideo(etat : any) {
    return this.http.get(this.urlServer+"Iec/find_etat2/"+etat)
      .map(resp => resp.json());
  }


  


  getIecParmocle(motcle : any) {
    return this.http.get(this.urlServer+"Iec/find_titre/"+motcle)
      .map(resp => resp.json());
  }

  getIecEpidemique(motcle : any,motcle2 : any) {
    return this.http.get(this.urlServer+"Iec/find_titrebyepid/"+motcle+"/"+motcle2)
      .map(resp => resp.json());
  }
//iec Détail

saveIecDetail(iecDetail: IecDetail): Observable<any> {
  let headers = new Headers();
  headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  let body = JSON.stringify(iecDetail);
  let options = new RequestOptions({ headers: headers });
  return this.http.post(this.urlServer + "IecDetailCreate", body, options);
}

updateIecDetail(iecDetail: IecDetail): Observable<any> {
  let headers = new Headers();
  headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  let body = JSON.stringify(iecDetail);
  let options = new RequestOptions({ headers: headers });
  return this.http.post(this.urlServer+ "Iec/update_iec_detail/"+ iecDetail.id_detail_iec, body, options);  
}

deleteIecDetail(id_detail_iec:number): Observable<any> {
  return this.http.delete(this.urlServer + "Iec/delete_iec_detail/"+id_detail_iec)
    .map(resp => resp.json());
}

  

//iec   

  saveIec(iec: Iec): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(iec);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+"IecCreate", body, options);
  }


  updateIec(iec: Iec): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(iec);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Iec/update/"+ iec.id_iec, body, options);  
  }

  deleteIec(id_iec:number): Observable<any> {
    return this.http.delete(this.urlServer + "Iec/delete/"+id_iec)
      .map(resp => resp.json());
  }
  
  getIecAllFichier() {
    return this.http.get(this.urlServer+"Iec")
      .map(resp => resp.json());
  }

  getIecPDF(id_iec:any) {
    return this.http.get(this.urlServer+"Iec/find_pdf/"+id_iec)
      .map(resp => resp.json());
  }

  

  getInfoIEC(id_iec:any) {
    return this.http.get(this.urlServer+"Iec/find/"+id_iec)
      .map(resp => resp.json());
  }

  getListeIECDetail(id_iec:any,etat:any) {
    return this.http.get(this.urlServer+"Iec/find_list_detail/"+id_iec+"/"+etat)
      .map(resp => resp.json());
  }

  getInfoIECDetail(id_iec:any,etat:any) {
    return this.http.get(this.urlServer+"Iec/find_detail/"+id_iec+"/"+etat)
      .map(resp => resp.json());
  }

  getInfoIECDetailById(id_iec:any) {
    return this.http.get(this.urlServer+"Iec/find_detail_by_id/"+id_iec)
      .map(resp => resp.json());
  }


  //image CMS
  saveIecImage(infra: Infra): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(infra);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+"IecCreateImage", body, options);
  }

  updateIecImage(infra: Infra): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(infra);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Iec/update_image/"+ infra.id_infra, body, options);  
  }

  

  getInfoImage(id_iec:any) {
    return this.http.get(this.urlServer+"Iec/find_image/"+id_iec)
      .map(resp => resp.json());
  }

  deleteIecImage(id_infra:number): Observable<any> {
    return this.http.delete(this.urlServer + "Iec/delete_image/"+id_infra)
      .map(resp => resp.json());
  }


  //getse barriere 

  getDesafection(id_iec:any) {
    return this.http.get(this.urlServer+"Iec/find_Gest_Barr/"+id_iec)
      .map(resp => resp.json());
  }

  getInfoGesteBarriere(id_iec:any) {
    return this.http.get(this.urlServer+"Iec/find_Gest_Barr_login/"+id_iec)
      .map(resp => resp.json());
  }

  


  

  


  //entrepot med livrer
  
  getMedLivrer() {
    return this.http.get(this.urlServer+"Rapport_activite/find_entrepot")
      .map(resp => resp.json());
  }

  getInfoMedLivrer(id_med_liv:any) {
    return this.http.get(this.urlServer+"Rapport_activite/find_info_entrepot/"+id_med_liv)
      .map(resp => resp.json());
  }

 filtrerMedLivrer(id_med_liv:any) {
    return this.http.get(this.urlServer+"Rapport_activite/filtre_titre/"+id_med_liv)
      .map(resp => resp.json());
  }

  saveMedLivrer(medicamentLivre: MedicamentLivre): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(medicamentLivre);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "MedLivrerCreate", body, options);
  }


  updateMedLivrer(medicamentLivre: MedicamentLivre): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(medicamentLivre);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Rapport_activite/update_entrepot/"+ medicamentLivre.id_med_liv, body, options);  
  }

  deleteMedLivrer(id_med_liv:number): Observable<any> {
    return this.http.delete(this.urlServer + "Rapport_activite/delete_entrepot/"+id_med_liv)
      .map(resp => resp.json());
  }

  //detail med livrer

  

  getMedLivrerDetail(id_med_liv:any) {
    return this.http.get(this.urlServer+"Rapport_activite/find_detail_entrepot/"+id_med_liv)
      .map(resp => resp.json());
  }



  //Text et lois

  getText() {
    return this.http.get(this.urlServer+"Iec/find_text_lois/")
      .map(resp => resp.json());
  }

  getDetailText(id_text:any) {
    return this.http.get(this.urlServer+"Iec/find_detail_text_lois/"+id_text)
      .map(resp => resp.json());
  }

  getTextParmocle(motcle : any) {
    return this.http.get(this.urlServer+"Iec/find_text_lois_titre/"+motcle)
      .map(resp => resp.json());
  }

  //Bibliotheque virtuelle

  getBibliotheque() {
    return this.http.get(this.urlServer+"Iec/find_bibliotheque/")
      .map(resp => resp.json());
  }

  getDetailBibliotheque(id_biblio:any) {
    return this.http.get(this.urlServer+"Iec/find_detail_bibliotheque/"+id_biblio)
      .map(resp => resp.json());
  }


  getBibliothequeParmocle(motcle : any) {
    return this.http.get(this.urlServer+"Iec/find_bibliotheque_titre/"+motcle)
      .map(resp => resp.json());
  }






  //entrepot med livrer

  getevolutionepidemieParMotCle(mcl:any){
 return this.http.get(this.urlServer+"Iec/find_epidemimie_by_mcl/"+mcl)
      .map(resp => resp.json());
  }
  
  getevolutionepidemie() {
    return this.http.get(this.urlServer+"Iec/find_epidemimie")
      .map(resp => resp.json());
  }

  getInfoEvolutionEpidemie(id_epid:any) {
    return this.http.get(this.urlServer+"Iec/find_detail_epidemimie/"+id_epid)
      .map(resp => resp.json());
  }

  getInfoEvolutionEpidemiebyetet(eta_epi:any) {
    return this.http.get(this.urlServer+"Iec/find_detail_epidemimie_etat/"+eta_epi)
      .map(resp => resp.json());
  }

  



  saveEvolutionEpidemie(epidemimie: Epidemimie): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(epidemimie);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "EpidemimieCreate", body, options);
  }


  updateEvolutionEpidemie(epidemimie: Epidemimie): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(epidemimie);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Iec/update_epidemimie/"+ epidemimie.id_epid, body, options);  
  }


  deleteEvolutionEpidemie(id_med_liv:number): Observable<any> {
    return this.http.delete(this.urlServer + "Iec/delete_epidemimie/"+id_med_liv)
      .map(resp => resp.json());
  }



  //getlisteApropos

  getlisteApropos() {
    return this.http.get(this.urlServer+"Iec/find_apropos")
      .map(resp => resp.json());
  }

  getInfoapropos(id_appro:any) {
    return this.http.get(this.urlServer+"Iec/find_apropos_by_id/"+id_appro)
      .map(resp => resp.json());
  }


  saveApropos(apropos: Apropos): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(apropos);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "AproposCreate", body, options);
  }


  updateApropose(apropos: Apropos): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(apropos);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Iec/update_apropos/"+ apropos.id_apropos, body, options);  
  }


  deleteApropos(id_apropos:number): Observable<any> {
    return this.http.delete(this.urlServer + "Iec/delete_apropos/"+id_apropos)
      .map(resp => resp.json());
  }


  //***************   debut getBCAgent          ********************

  getBCAgent() {
    return this.http.get(this.urlServer+"Bc")
      .map(resp => resp.json());
  }

   getBCAgentByIM(im:any) {
    return this.http.get(this.urlServer+"Bc/findIm/"+im)
      .map(resp => resp.json());
  }

  getBCAgentByDirByEtat(dir:any, etat:any) {
    return this.http.get(this.urlServer+"Bc/findDirEtat/"+dir+"/"+etat)
      .map(resp => resp.json());
  }

  getInfoBc(id_bc:any) {
    return this.http.get(this.urlServer+"Bc/find/"+id_bc)
      .map(resp => resp.json());
  }

  getInfoNumBc(id_bc:any) {
    return this.http.get(this.urlServer+"Bc/find_On_NumBC/"+id_bc)
      .map(resp => resp.json());
  }


  


  saveBc(_bc: BC): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(_bc);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer + "BcCreate", body, options);
  }

   updateBc(_bc: BC): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(_bc);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Bc/update/"+ _bc.id_bc, body, options);  
  }


  //detail BC
  getNumBC(id_bc:any) {
    return this.http.get(this.urlServer+"Bc/findNumBC/"+id_bc)
      .map(resp => resp.json());
  }

  
  getInfoNumBcbyBcId(id_bc:any) {
    return this.http.get(this.urlServer+"Bc/findOnNumBCbyIdBc/"+id_bc)
      .map(resp => resp.json());
  }


  saveNumBc(_BC_detail: BC_detail): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(_BC_detail);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+"BcCreateNum", body, options);
  }

   updateNumBc(_BC_detail: BC_detail): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(_BC_detail);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Bc/update_num/"+ _BC_detail.id_detail_bc, body, options);  
  }
  

  deleteNumBC(id_detail_bc:number): Observable<any> {
    return this.http.delete(this.urlServer + "Bc/delete_num_bc/"+id_detail_bc)
      .map(resp => resp.json());
  }






  getLibelleType(libelle_code){
      if(!libelle_code)return "VIDE";
     // if(libelle_code=="")
      if(libelle_code=="A") return "Création";
      if(libelle_code=="R") return "Rejeté";
      if(libelle_code=="V") return "Validé";
      if(libelle_code=="U") return "Urgence";
      if(libelle_code=="ACT") return "Actif";
      if(libelle_code=="DACT") return "Déja actif";
      return libelle_code;
    }


    getLibelleTypeUser(libelle_user){
      if(!libelle_user)return "VIDE";
     // if(libelle_code=="")
      if(libelle_user=="1") return "Admin";
      if(libelle_user=="2") return "Agent";
      if(libelle_user=="3") return "Communication";
      if(libelle_user=="4") return "Supperviseur";
      if(libelle_user=="5") return "Validateur BC";
     
      return libelle_user;
    }


    getLibelleDirection(libelle_dir){
     
       if(!libelle_dir)return "VIDE";
     // if(libelle_code=="")
      if(libelle_dir=="DAF") return "DIRECTION ADMINISTRATIVE ET FINANCIERE";
      if(libelle_dir=="DRH") return "DIRECTION DES RESSOURCES HUMAINES";
      if(libelle_dir=="DSI") return "DIRECTION DES SYSTEMES D'INFORMATION";
     
      return libelle_dir;
    }






   

    // return this.http.get("http://rohi.mfb.gov.mg:8088/ROHI/service/agent?q="+event+"&zHashCode="+code)
    //  .map(resp => resp.json());


  //***************   fin  getBCAgent          ********************

//user admin
  getUser() {
    return this.http.get(this.urlServer+"Users")
      .map(resp => resp.json());
  } 

  getUserType() {
    return this.http.get(this.urlServer+"Users/find_type_user")
      .map(resp => resp.json());
  } 

   

   saveUser(_users: Users): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(_users);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+"UsersCreate", body, options);
  } 

  getUsebyId(id_user:any) {
    return this.http.get(this.urlServer+"Users/find/"+id_user)
      .map(resp => resp.json());
  }

   getUsebyIM(id_user:any) {
    return this.http.get(this.urlServer+"Users/findbyIM/"+id_user)
      .map(resp => resp.json());
  }

  


  
   updateUser(_users: Users): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let body = JSON.stringify(_users);
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.urlServer+ "Users/update/"+ _users.id_user, body, options);  
  }
  

  deleteUser(id_user:number): Observable<any> {
    return this.http.delete(this.urlServer + "Users/delete/"+id_user)
      .map(resp => resp.json());
  }
  


  
 
  
  

  
 

}
